import React from 'react';
import { Modal } from 'antd';



const PDFViewer = ({ visible, onClose, comprobante }) => {
  if (!comprobante) return null;
console.log("comprobante", comprobante);

  const pdfUrl = `${process.env.REACT_APP_URL_DIRECTUS}/assets/${comprobante}`;

  return (
    <Modal
      title="Comprobante"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      style={{ top: 20 }}
    >
      <iframe
        src={pdfUrl}
        style={{
          width: '100%',
          height: '80vh',
          border: 'none'
        }}
        title="PDF Viewer"
      />
    </Modal>
  );
};

export default PDFViewer; 